import * as React from 'react';
import Avatar from '@mui/material/Avatar';

export default function AvatarDesign({
    alt = 'User Avatar',
    src = 'https://img.freepik.com/free-photo/3d-illustration-teenager-with-funny-face-glasses_1142-50955.jpg?t=st=1721627721~exp=1721631321~hmac=59e0f2165b23e83a9090d820c1a64bad1f41ccce3a6b6b81dc358143b1ba99b0&w=740',
    sx = {
        width: 42,
        height: 42
    }
}) {
    return <Avatar size="lg" variant="soft" alt={alt} src={src} sx={sx} />;
}
